import { useTranslations } from "next-intl";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import { usePrice } from "@hooks/use-prices";

function ValidationSummary({ expressDeliverySummary, expressDeliverySelected }) {
  const t = useTranslations("common");

  const price = usePrice();
  const { plan, add_ons_summary: addOnsSummary } = useCustomizableCloset();
  const addOnsToPayCount = addOnsSummary?.add_ons_count - addOnsSummary?.add_on_credits_to_spend;
  const expressDeliveryFee = expressDeliverySelected ? expressDeliverySummary?.price : 0;

  return (
    <div className="p-3 bg-white rounded-sm">
      <p className="font-size-sm font-weight-bold text-uppercase">
        {t("drawer.modal_rtc.validate.summary.title")}
      </p>

      <div className="d-flex flex-column gap-2">
        <div className="d-flex justify-content-between">
          <p className="font-size-sm mb-0">
            {t("drawer.modal_rtc.plans.swapable_families", {
              count: plan.clothes + plan.accessories,
            })}
          </p>

          <p className="font-size-sm font-weight-bold mb-0">
            {t("drawer.modal_rtc.validate.summary.included")}
          </p>
        </div>

        <div className="d-flex justify-content-between">
          <p className="font-size-sm mb-0">
            {t("drawer.modal_rtc.validate.summary.shipping_fees")}
          </p>

          <p className="font-size-sm font-weight-bold mb-0">
            {expressDeliverySelected
              ? price(expressDeliveryFee)
              : t("drawer.modal_rtc.validate.summary.included")}
          </p>
        </div>

        {addOnsSummary?.add_on_credits_to_spend > 0 && (
          <div className="d-flex justify-content-between">
            <p className="font-size-sm mb-0">
              {t("drawer.modal_rtc.validate.summary.bonus_item", {
                count: addOnsSummary.add_on_credits_to_spend,
              })}
            </p>

            <p className="font-size-sm font-weight-bold mb-0">
              {t("drawer.modal_rtc.change.add_on_counter.free", {
                count: addOnsSummary.add_on_credits_to_spend,
              })}
            </p>
          </div>
        )}

        {addOnsToPayCount > 0 && (
          <div className="d-flex justify-content-between">
            <p className="font-size-sm mb-0">
              {t("drawer.modal_rtc.validate.summary.bonus_item", { count: addOnsToPayCount })}
            </p>

            <p className="font-size-sm font-weight-bold mb-0">{price(addOnsSummary.rest_to_pay)}</p>
          </div>
        )}
      </div>

      <div className="mt-3 pt-3 border-top border-light d-flex justify-content-between">
        <p className="font-weight-bold mb-0">{t("drawer.modal_rtc.validate.summary.total")}</p>

        <p className="font-weight-bold mb-0">
          {price((addOnsSummary?.rest_to_pay || 0) + expressDeliveryFee)}
        </p>
      </div>
    </div>
  );
}

export default ValidationSummary;
